<template>
  <div></div>
</template>

<script setup>
// #region VUE
import {
  inject,
  onMounted,
} from 'vue';
// #endregion

// #region STTEDRA
import {
  useDev,
} from '@sttedra_ui/framework';
// #endregion

// #region COMPONENTS COMPOSABLES
import {useRouter} from 'vue-router';
import {useUrlSearchParams} from '@vueuse/core';
// #endregion

// #region Params, Ref, Reactives, Computed
const appState$$ = inject('appState$$');
const router = useRouter();
// #endregion

// #region Functions
function init() {
  try {
    const params = useUrlSearchParams('history');
    const token = params?.token || null;
    const error = params?.error || null;
    const isTutor = params?.tutor || false;

    if (appState$$.isOffline || !token || error) {
      appState$$.errorInLogin = error;
      appState$$.isLogged = false;
      appState$$.token = null;
      appState$$.isTutorizeRegister = false;
      appState$$.isTutorizeRegisterRedirect = false;
      goToHome();
      return;
    }

    appState$$.errorInLogin = null;
    appState$$.isLogged = true;
    appState$$.token = token;
    appState$$.isTutorizeRegister = isTutor == 1 ? true : false;
    appState$$.isTutorizeRegisterRedirect = true;
    goToHome();
  } catch (error) {
    useDev.error('[LoginOk.vue] init', error);
  }
}

function goToHome() {
  appState$$.setLoginApp(true);

  const dataRoute = {};
  router.push({
    name: `Home`,
    ...dataRoute,
  });
}
// #endregion

// #region Effects, Hooks
onMounted(() => {
  appState$$.isLoading = true;
  init();
});
// #endregion

</script>
